import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../App";
import { AlertTriangle } from "lucide-react";

/**
 * OCI V2.16 — compact Homepage passport banner.
 * Replaces the full PassportScoreCard on the fundraiser Homepage; the full card
 * now lives in My Records. Renders ONLY when there are outstanding actions.
 */
export function PassportAlertBanner({ userId }) {
  const navigate = useNavigate();
  const [actions, setActions] = useState([]);

  useEffect(() => {
    let active = true;
    (async () => {
      if (!userId) return;
      try {
        const r = await apiClient.get(`/workforce/users/${userId}/passport`);
        if (active) setActions(r.data?.passportActions || []);
      } catch (e) {
        if (active) setActions([]);
      }
    })();
    return () => { active = false; };
  }, [userId]);

  if (!actions || actions.length === 0) return null;

  return (
    <button
      onClick={() => navigate("/records")}
      data-testid="passport-alert-banner"
      className="w-full flex items-center gap-3 p-3 rounded-xl border border-amber-300 bg-amber-50 text-left hover:bg-amber-100 transition-colors"
    >
      <AlertTriangle className="h-5 w-5 text-amber-600 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-amber-900">Passport action required</p>
        <p className="text-xs text-amber-700">
          {actions.length} outstanding item{actions.length > 1 ? "s" : ""} — tap to review in My Records
        </p>
      </div>
    </button>
  );
}
